var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBed5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 4C2 3.44772 2.44772 3 3 3C3.55228 3 4 3.44772 4 4V14H5V13C5 12.4477 5.44772 12 6 12H18C18.5523 12 19 12.4477 19 13V14H20V13C20 12.4477 20.4477 12 21 12C21.5523 12 22 12.4477 22 13V20C22 20.5523 21.5523 21 21 21C20.4477 21 20 20.5523 20 20V16H19V18C19 18.5523 18.5523 19 18 19H6C5.44772 19 5 18.5523 5 18V16H4V20C4 20.5523 3.55228 21 3 21C2.44772 21 2 20.5523 2 20V4Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.50023 6.40217C5.77638 5.92388 6.38797 5.76 6.86626 6.03614L10.3304 8.03614C10.8087 8.31228 10.9725 8.92387 10.6964 9.40217L9.69639 11.1342C9.42024 11.6125 8.80865 11.7764 8.33036 11.5002L4.86626 9.50024C4.38797 9.2241 4.22409 8.61251 4.50023 8.13422L5.50023 6.40217Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBed5);
export default __webpack_public_path__ + "static/media/bed-5.7d83d68ccfbe6d1225d13b45d2ce16e6.svg";
export { ForwardRef as ReactComponent };